module.exports = __webpack_public_path__ + "static/media/bg8.c57724e4.jpg";